/**
 * TODO control should be explicit or layout could be updated before passing to form manager
 * Determines the type of control based on either an explicit value or
 * key attributes
 *
 * @param {Object} field Field config from page layout.
 * @return {String}
 */
export const determineControl = function (field) {
  // eslint-disable-line
  const DEFAULT_CONTROL = 'input';
  const control = (field.control || '').toLowerCase();

  // hack to ensure returned value is lowercase
  return (() => {
    // Ignore field type element
    if (field.type === 'element') {
      return field.control;
    }

    // Explicit control given
    if (control && control !== 'tags' && control !== 'search') {
      const controlNames = this.getControlNames();
      if (!controlNames.includes(control)) {
        console.error(
          `Invalid control ${field.control} given for field ${field.name}. Valid controls are: ${controlNames.join(
            ','
          )}.`
        );
        return DEFAULT_CONTROL;
      }

      return field.control;
    }

    // An array of data but not part of a collection indicates a Tags component
    if (control === 'tags' || (Array.isArray(field.data) && !field.insideTable)) {
      if (!field.validation) {
        return 'tags';
      }

      switch (field.validation.type) {
        case 'db':
          return 'TagsDbSearch';

        case 'customer':
          return 'TagsCustomerSearch';

        case 'customervehicle':
          return 'TagsCustomerVehicleSearch';

        case 'vehicle':
          return 'TagsVehicleSearch';

        case 'vehiclesale':
          return 'TagsVehicleSaleSearch';

        case 'repair':
          return 'TagsRepairSearch';

        case 'account':
          return 'TagsAccountSearch';

        case 'vendor':
          return 'TagsVendorSearch';

        case 'page':
          return 'TagsPageSearch';

        case 'static':
          return 'TagsStaticSearch';

        // no default
      }

      if (field.validation.page) {
        return 'TagsListSearch';
      }

      return 'Tags';
    }

    // Validation key usually indicates a Search component
    if (field.validation || (field.type === 'zipcode' && this.features.zipcodelist)) {
      if (field.type === 'zipcode') {
        return 'ZipcodeSearch';
      }

      switch (field.validation.type) {
        case 'db':
          return 'DbSearch';

        case 'customer':
          return 'CustomerSearch';

        case 'customervehicle':
          return 'CustomerVehicleSearch';

        case 'vehicle':
          return 'VehicleSearch';

        case 'vehiclesale':
          return 'VehicleSaleSearch';

        case 'repair':
          return 'RepairSearch';

        case 'account':
          return 'AccountSearch';

        case 'vendor':
          return 'VendorSearch';

        case 'page':
          return 'PageSearch';

        case 'simple':
          return 'SimpleSearch';

        case 'static':
          return 'StaticSearch';

        // no default
      }

      if (field.validation.list) {
        return 'SimpleSearch';
      }

      return 'ListSearch';
    }

    // Options key usually indicates a Select component
    if (field.options) {
      return 'Select';
    }

    if (field.type === 'file') {
      return 'Upload';
    }

    if (field.type === 'date') {
      return 'Calendar';
    }

    if (field.type === 'runtimedate') {
      return 'RuntimeDate';
    }

    if (field.type === 'color') {
      return 'ColorPicker';
    }

    return DEFAULT_CONTROL;
  })().toLowerCase();
};
